import * as React from 'react';
import { biLogger } from '../../../bi';
import { config } from '../../../config';
import s from '../modals.scss';
import { Modal, MessageBoxMarketerialLayout } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
export var AdiEditorModal = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (_a) {
    var t = _a.t, appId = _a.appId, msid = _a.msid, marketplaceStore = _a.marketplaceStore, appIcon = _a.appIcon, appName = _a.appName;
    var handleClose = function () {
        // tslint:disable-next-line: no-floating-promises
        biLogger.appMarketCloseDialogBoxOfUpgradeWixX({
            app_id: appId,
            msid: msid,
        });
        marketplaceStore.closeAllModals();
    };
    var handleConnect = function () {
        window.open(config.editorUrl + "etpa/add-app?" + appId);
    };
    // tslint:disable-next-line: no-floating-promises
    biLogger.appMarketUpgradeSiteConnectDomainDialogBox({
        appId: appId,
        msid: msid,
        stepName: 'adi_editor',
    });
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageBoxMarketerialLayout, { title: React.createElement(React.Fragment, null,
                React.createElement("img", { className: s.appIcon, src: appIcon }),
                React.createElement("div", null, t('modals-adiEditor-header', { appName: appName }))), content: t('modals-adiEditor-content', { appName: appName }), theme: "white", primaryButtonLabel: t('modals-adiEditor-cta'), primaryButtonTheme: "blue", onClose: function () { return handleClose(); }, onPrimaryButtonClick: function () { return handleConnect(); } })));
});
//# sourceMappingURL=adi-editor-modal.js.map